export default __webpack_public_path__ + "static/media/testimonial-student-one.bcc9586c.png";